import { AccessibilityUnitLevelQuery } from "../models/AccessibilityLevel";
import { BuildArea } from "../models/BuildArea";
import { baseUrl, fetchAndParse, headers } from "./utils"

export const retrieveBuildingAreaById = (id: string) => {
    const url = new URL(`/building_areas/${id}/`, baseUrl);
    return fetchAndParse<BuildArea>(url.toString(), { method: "GET", headers })
}

export const retrieveBuildingAreasAccessibilityByType = (buildingAreaId: string, accessibilityType: string, filter? : string) => {
    const url = new URL(`/accessibility-unit-levels/?accessibility_unit__type=${accessibilityType}&accessibility_unit__property__building_area__id=${buildingAreaId}&fields=${filter}`, baseUrl);
    return fetchAndParse<AccessibilityUnitLevelQuery>(url.toString(), { method: "GET", headers })
} 